const apiVersion = 'v1'

export const LOGIN_REQUEST = `auth/${apiVersion}/login/`
export const LOGOUT_REQUEST = `auth/${apiVersion}/logout/`
export const CHANGE_PASSWORD = `auth/${apiVersion}/change-password/`
export const VERIFY_SECURITY_CODE = `auth/${apiVersion}/verify-security-code/`
export const RESEND_SECURITY_CODE = `auth/${apiVersion}/resend-security-code/`
export const RESET_PASSWORD = `auth/${apiVersion}/reset-password/`
